import { questionSchema } from '../schemas';
import { questionTypes } from '../constants';

export const fetchQuestionData = (questionUID) => ({
  type: questionTypes.FETCH_QUESTION_DATA,
  method: 'get',
  endpoint: `v1/quizzes/question/details/?uid=${questionUID}&multi_language_support=1`
});

export const fetchQuestionDataV2 = (questionUID, language) => ({
  type: questionTypes.FETCH_QUESTION_DATA_V2,
  method: 'get',
  endpoint: `v2/quizzes/question/details/?uid=${questionUID}&language=${language}`
});

export const submitQuestionDetails = (
  uid,
  difficulty_level,
  expected_time
) => ({
  type: questionTypes.SUBMIT_QUESTION_DETAILS,
  method: 'post',
  endpoint: 'v2/quizzes/question/update_question/',
  difficulty_level,
  expected_time,
  data: {
    uid,
    difficulty_level,
    expected_time
  }
});

export const submitSolutionRecording = (room_uid) => ({
  type: questionTypes.SUBMIT_SOLUTION_RECORDING,
  method: 'post',
  endpoint: 'v1/live/room/submit_recording/',
  data: { room_uid }
});

export const fetchQuestionInfo = ({ questionUID }) => (dispatch) =>
  dispatch({
    type: questionTypes.FETCH_QUESTION_INFO,
    endpoint: `v1/quizzes/question/info/?uid=${questionUID}`,
    method: 'get',
    schema: questionSchema
  });

export const fetchConcepts = (query, goalUID) => ({
  type: questionTypes.FETCH_CONCEPT,
  method: 'get',
  endpoint: `v1/topology/goal/search_concepts/?q=${encodeURIComponent(
    query
  )}&goal_uid=${goalUID}`
});

export const toggleQuestionStatus = (is_active, uid) => ({
  type: questionTypes.TOGGLE_QUESTION_STATUS,
  method: 'post',
  endpoint: 'v1/quizzes/question/toggle_status/',
  data: { is_active, uid },
  isActive: is_active
});

export const editOption = (id, value) => ({
  type: questionTypes.EDIT_OPTION,
  id,
  value
});

export const saveQuestion = (data, quizUID) => ({
  type: questionTypes.SAVE_QUESTION,
  method: 'post',
  endpoint: `v2/quizzes/me/create_or_update_quiz_question/${
    quizUID ? `${quizUID}/` : ''
  }`,
  data
});

export const editContent = ({ value, languages, language, id }) => ({
  type: questionTypes.EDIT_CONTENT,
  id,
  value,
  language,
  languages
});

export const editAnswer = (value, language, option) => ({
  type: questionTypes.EDIT_ANSWER,
  value,
  language,
  option
});

export const editHint = (value, language, option) => ({
  type: questionTypes.EDIT_HINT,
  value,
  language,
  option
});

export const editLanguage = (value, incrementNoPreference, newId, oldId) => ({
  type: questionTypes.EDIT_LANGUAGE,
  value,
  incrementNoPreference,
  newId,
  oldId
});

export const markCorrect = (rank, isMultipleCorrect = false) => ({
  type: questionTypes.MARK_CORRECT,
  rank,
  isMultipleCorrect
});

export const markIsCommon = (index) => ({
  type: questionTypes.MARK_IS_COMMON,
  index
});

export const addOption = () => ({
  type: questionTypes.ADD_OPTION
});

export const removeOption = () => ({
  type: questionTypes.REMOVE_OPTION
});

export const deleteLanguage = (language) => ({
  type: questionTypes.REMOVE_LANGUAGE,
  language
});

export const setNumberOfOptions = (value) => ({
  type: questionTypes.SET_NUMBER_OPTIONS,
  value
});

export const loadQuestionContent = (data) => ({
  type: questionTypes.SETUP_DATA,
  data
});
